import React, {useState}     from 'react'

//import TemplateApply                    from '../Template/TemplateApply'
import BookingOverlay                   from './BookingOverlay'
import RotaOverlay                      from './RotaOverlay'
import NCAOverlay                       from './NCAOverlay'
import RotaDeleteOverlay                from './RotaDeleteOverlay'
import RotaCopyOverlay                  from './RotaCopyOverlay'
import BookingProcessOverlay            from './BookingProcessOverlay';
import WorkingHoursOverlay              from '../WorkingHours/WorkingHoursOverlay';
//import SelectRegionOverlay              from './SelectRegionOverlay'


/* 
 * REACTJs component to display an overlay over the diary for editing 
 * availablility
 */
const TeamCalendarOverlay = ({api, calendarEvent, setCalendarEvent, 
    calendarApi, state, eventDispatch}) => {    

    const { action = null, event: eventInfo = {} } = ( calendarEvent? calendarEvent: {} )

    const {
            // start, 
            // end, 
                extendedProps: 
                    { apiEvent: { RotaID: rotaID,
                                //   PartyID: ePartyID,
                                //   RotaTypeID: defaultRotaTypeID = 0 
                                } = {} } = {},
                // resource: { id: rPartyID} = {} 
            } = eventInfo
    /* comes from internal event or api depending whether we are creating a new 
     * rota entry */
    // const partyID = rPartyID? rPartyID: ePartyID


    const [error, setError]                     = useState('')
    
    const done = () => {
        setError(null);
        // rerenender and load events
        if( calendarApi.current.render ){
            calendarApi.current.render()
        }
        if( calendarApi.current.getApi() ){
            const capi = calendarApi.current.getApi()
            capi.refetchEvents();
        }
        
        setCalendarEvent(null)
        
    }   
    
    const showTypeSelect = () => {
        
        switch (action){
            
            case 'selectRegion':
            case 'NCAEventClick':
                return <NCAOverlay api={api} selectInfo={eventInfo} 
                    done={done} calendarApi={calendarApi} setError={setError} 
                    state={state} eventDispatch={eventDispatch} />
            case 'selectRotaRegion':
            case 'rotaEventClick':
                return <RotaOverlay api={api} selectInfo={eventInfo} 
                    done={done} calendarApi={calendarApi} setError={setError} 
                    state={state} />
//            case 'selectRegion----NOT USING':
//                return <SelectRegionOverlay api={api} selectInfo={eventInfo}  
 //                   done={//done} calendarApi={calendarApi} setError={setError} 
//                    state={//state} eventDispatch={eventDispatch} />
//                break
            case 'bookingEventClick':
                return <BookingOverlay api={api} selectInfo={eventInfo}  
                    done={done} calendarApi={calendarApi} setError={setError} 
                    state={state} eventDispatch={eventDispatch} />
            case 'BookingProcessOverlay':
                return <BookingProcessOverlay api={api} selectInfo={eventInfo}  
                    done={done} calendarApi={calendarApi} setError={setError} 
                    state={state} eventDispatch={eventDispatch} />
            case 'delete':
                return (<RotaDeleteOverlay api={api} rotaID={rotaID}  
                                done={done} setError={setError} />)
            case 'copy':
                return (<RotaCopyOverlay api={api} rotaID={rotaID}
                            selectInfo={eventInfo} done={done}
                            setError={setError} />)
            case 'workingHours':
                // refetch resources so the calendar shading picks up a change
                return (<WorkingHoursOverlay api={api} partyID={eventInfo.partyID}
                            name={eventInfo.name}
                            done={changed => {
                                if( changed ){
                                    calendarApi.current?.getApi()?.refetchResources();
                                }
                                done();
                            }} />)
            default:
                <div>'Invalid overlay \'' + action + '\''</div>
                //throw 'Invalid overlay \'' + action + '\''
        }
    }
    
    // Overlays already moved onto Util/Dialog draw their own box
    if( 'workingHours' === action ){
        return showTypeSelect()
    }

    return (
       <>
        {action?
       <div style={{position: 'absolute', display: 'block', top: '50%', 
            left: '50%',backgroundColor: 'white', zIndex: '100', padding: '2em', 
            border: '3px solid var(--colour__primary)'}}  >
            
           
            
            {true? showTypeSelect(): ''}
            
            <pre>{false? JSON.stringify( eventInfo, null, '\t' ): ''}</pre>
            
            
            <div>{error}</div>
       </div>:null}
       </>
    )
}



export default TeamCalendarOverlay

